import React, { createContext, useContext, useState, useCallback } from 'react';
import api from '../api';

const SuperAdminContext = createContext(null);

export function SuperAdminProvider({ children }) {
  const [saUser, setSaUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('turismo_sa_user')); } catch { return null; }
  });
  const [saToken, setSaToken] = useState(() => localStorage.getItem('turismo_sa_token'));

  const login = useCallback(async (username, password) => {
    const res = await api.post('/superadmin/auth/login', { username, password });
    const { access_token } = res.data;
    const u = { username };
    localStorage.setItem('turismo_sa_token', access_token);
    localStorage.setItem('turismo_sa_user', JSON.stringify(u));
    setSaToken(access_token);
    setSaUser(u);
    return u;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('turismo_sa_token');
    localStorage.removeItem('turismo_sa_user');
    setSaToken(null);
    setSaUser(null);
    window.location.href = '/superadmin/login';
  }, []);

  const isAuthenticated = Boolean(saToken && saUser);

  return (
    <SuperAdminContext.Provider value={{ saUser, saToken, isAuthenticated, login, logout }}>
      {children}
    </SuperAdminContext.Provider>
  );
}

export function useSuperAdmin() {
  return useContext(SuperAdminContext);
}
